module.exports = __webpack_public_path__ + "static/media/Charles Montgomery Burns.fb79cd08.png";